// Times shown in the user's chosen time zone (profile), else the browser's.
let TZ;

export const setTimeZone = (tz) => { TZ = tz || undefined; };
export const getTimeZone = () => TZ;

const PARTS = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" };

const CT = "America/Chicago";
const WD = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const wall = (d, zone) => Object.fromEntries(new Intl.DateTimeFormat("en-US", { ...PARTS, timeZone: zone }).formatToParts(d).map((x) => [x.type, +x.value || x.value]));
const offset = (ms, zone) => { const p = wall(new Date(ms), zone); return Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute) - Math.floor(ms / 60000) * 60000; };

// Zoned ISO -> that instant; naive "YYYY-MM-DD[T ]HH:MM" -> US Central wall time (how the backend sends load/trip times)
export const toDate = (s) => {
  const v = String(s || "");
  if (/(Z|[+-]\d{2}:?\d{2})$/.test(v) && /T\d{2}:\d{2}/.test(v)) { const d = new Date(v); return Number.isNaN(d.getTime()) ? null : d; }
  const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(v);
  if (!m) return null;
  const g = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
  return new Date(g - offset(g - offset(g, CT), CT));
};

// Any time string -> "YYYY-MM-DD HH:MM" in the chosen zone (date-only strings unchanged)
export const zoneTime = (s) => {
  const d = toDate(s);
  if (!d) return String(s || "").slice(0, 16).replace("T", " ");
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", { ...PARTS, timeZone: TZ }).formatToParts(d).map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}`;
};

// "Fri 10/09 08:00" in the chosen zone
export const zoneDayTime = (s) => {
  const t = zoneTime(s);
  if (!/\d{2}:\d{2}$/.test(t)) return t || null;
  const wd = WD[new Date(`${t.slice(0, 10)}T12:00:00Z`).getUTCDay()];
  return `${wd} ${t.slice(5, 7)}/${t.slice(8, 10)} ${t.slice(11)}`;
};

// Short zone name for labels, e.g. "CDT", "EST", "GMT+3"
export const tzLabel = () => new Intl.DateTimeFormat("en-US", { timeZone: TZ, timeZoneName: "short" }).formatToParts(new Date()).find((x) => x.type === "timeZoneName")?.value || "";

// Date#toLocale*String with a clock time but no explicit zone -> chosen zone
const TIMEY = ["hour", "minute", "timeStyle"];
["toLocaleString", "toLocaleTimeString"].forEach((fn) => {
  const orig = Date.prototype[fn];
  Date.prototype[fn] = function (loc, opts) {
    if (!TZ || (opts && opts.timeZone) || (opts && !TIMEY.some((k) => k in opts) && fn === "toLocaleString" && ("month" in opts || "year" in opts || "weekday" in opts || "dateStyle" in opts))) return orig.call(this, loc, opts);
    return orig.call(this, loc, { ...(opts || {}), timeZone: TZ });
  };
});
const origDate = Date.prototype.toLocaleDateString;
Date.prototype.toLocaleDateString = function (loc, opts) {
  if (!TZ || !opts || opts.timeZone || !TIMEY.some((k) => k in opts)) return origDate.call(this, loc, opts);
  return origDate.call(this, loc, { ...opts, timeZone: TZ });
};

export const localTime = zoneTime;

export const TIME_ZONES = [
  ["", "Browser time zone"],
  ["America/New_York", "Eastern (New York)"],
  ["America/Chicago", "Central (Chicago)"],
  ["America/Denver", "Mountain (Denver)"],
  ["America/Phoenix", "Arizona (Phoenix)"],
  ["America/Los_Angeles", "Pacific (Los Angeles)"],
  ["UTC", "UTC"],
  ["Europe/Kyiv", "Kyiv"],
  ["Asia/Tbilisi", "Tbilisi"],
];
